'use strict';

var templates = require('../templates');
var fobclient = require('..');
var Person = require('../entity').Person;

module.exports = function (connection) {
  return {
    byCnEquals: function byCnEquals(cn, additionalParams) {
      return templates.searchTemplate(connection)(Person, 'byCnEquals', 'cn')(cn, additionalParams);
    },
    byCnLike: function byCnLike(cn, additionalParams) {
      return templates.searchTemplate(connection)(Person, 'byCnLike', 'cn')(cn, additionalParams);
    },
    byNameEquals: function byNameEquals(name, additionalParams) {
      return templates.searchTemplate(connection)(Person, 'byNameEquals', 'name')(name, additionalParams);
    },
    byNameLike: function byNameLike(name, additionalParams) {
      return templates.searchTemplate(connection)(Person, 'byNameLike', 'name')(name, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(Person, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    byTitelEquals: function byTitelEquals(titel, additionalParams) {
      return templates.searchTemplate(connection)(Person, 'byTitelEquals', 'titel')(titel, additionalParams);
    },
    byTitelLike: function byTitelLike(titel, additionalParams) {
      return templates.searchTemplate(connection)(Person, 'byTitelLike', 'titel')(titel, additionalParams);
    },
    byVornameEquals: function byVornameEquals(vorname, additionalParams) {
      return templates.searchTemplate(connection)(Person, 'byVornameEquals', 'vorname')(vorname, additionalParams);
    },
    byVornameLike: function byVornameLike(vorname, additionalParams) {
      return templates.searchTemplate(connection)(Person, 'byVornameLike', 'vorname')(vorname, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(Person, 'genericand')(searchParams);
    },
    byMultiValueSearchRep: function byMultiValueSearchRep(searchParams) {
      return templates.genericSearchTemplate(connection)(Person, 'byMultiValueSearchRep')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('person')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/person.js
// module id = 2Ddb
// module chunks = 0